import React, { useMemo } from 'react';
import { TextField } from 'ksnm-common-ui/lib/Form/InputFields';
import { createMask } from 'ksnm-common-ui/lib/MaskedInput';

const min = -2_147_483_647;
const max = 2_147_483_647;

export const IntegerField = (props: {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  key?: string;
}): React.ReactElement => {
  const mask = useMemo(() => createMask('INTEGER_WITHOUT_RADIX', { thousandsSeparator: '', min, max }), []);

  return <TextField {...props} mask={mask} unmask max={max} min={min} />;
};
